import React, { useState } from 'react';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import StarIcon from '@mui/icons-material/Star';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const sortingOptions = [
  { name: 'Shoppa Favoriter', id: 'favorites', icon: <StarIcon style={{ fontSize: 20 }} />, desc: 'Populäraste först' },
  { name: 'Lägst Pris', id: 'lowestPrice', icon: <TrendingDownIcon style={{ fontSize: 20 }} />, desc: 'Billigaste först' },
  { name: 'Högst Pris', id: 'highestPrice', icon: <TrendingUpIcon style={{ fontSize: 20 }} />, desc: 'Dyraste först' },
  { name: 'Publiceringsdatum', id: 'publishDate', icon: <CalendarMonthIcon style={{ fontSize: 20 }} />, desc: 'Nyaste först' },
];

const SortingFilter = (props) => {
  const [selectedSorting, setSelectedSorting] = useState('');

  const handleSortingChange = (id) => {
    const next = selectedSorting === id ? '' : id;
    setSelectedSorting(next);
    if (props.setSelectedSortOn) props.setSelectedSortOn(next);
  };

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {sortingOptions.map((option) => {
          const active = selectedSorting === option.id;
          return (
            <button
              key={option.id}
              onClick={() => handleSortingChange(option.id)}
              style={{
                display: 'flex', alignItems: 'center', gap: '14px',
                padding: '14px 16px', borderRadius: '12px', cursor: 'pointer',
                border: active ? '2px solid #161825' : '2px solid #eee',
                backgroundColor: active ? '#f8f7ff' : '#fff',
                transition: 'all 0.15s ease', textAlign: 'left',
                width: '100%',
              }}
              onMouseOver={(e) => { if (!active) e.currentTarget.style.borderColor = '#ccc'; }}
              onMouseOut={(e) => { if (!active) e.currentTarget.style.borderColor = '#eee'; }}
            >
              <div style={{
                width: 40, height: 40, borderRadius: '10px', flexShrink: 0,
                backgroundColor: active ? '#161825' : '#f5f5f5',
                color: active ? '#fff' : '#666',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: 'all 0.15s ease',
              }}>
                {option.icon}
              </div>
              <div>
                <div style={{ fontSize: '14px', fontWeight: 600, color: '#222' }}>{option.name}</div>
                <div style={{ fontSize: '12px', color: '#888', marginTop: 2 }}>{option.desc}</div>
              </div>
              {active && (
                <div style={{ marginLeft: 'auto', flexShrink: 0 }}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <circle cx="10" cy="10" r="10" fill="#161825" />
                    <path d="M6 10.5L8.5 13L14 7.5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SortingFilter;
